import apiFetch from '../apiFetch'

export default function (token, data) {
  return apiFetch({ endPoint: 'Fleets/GetDossiersToAssign', method: 'POST', body: data, token: token })
}
